import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from 'styles/colors';

const loadingFirst = keyframes`
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
`;

const loadingThird = keyframes`
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
`;

const loadingSecond = keyframes`
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(24px, 0);
  }
`;

const Loader = () => (
   <Wrapper>
      <FirstChild />
      <SecondChild />
      <ThirdChild />
      <FourthChild />
   </Wrapper>
);

const Child = styled.div`
   position: absolute;
   top: 33px;
   width: 8px;
   height: 8px;
   border-radius: 50%;
   background: ${colors.primary};
   animation-timing-function: cubic-bezier(0, 1, 1, 0);
`;

const FirstChild = styled(Child)`
   left: 8px;
   animation: ${loadingFirst} 0.6s infinite;
`;

const SecondChild = styled(Child)`
   left: 8px;
   animation: ${loadingSecond} 0.6s infinite;
`;

const ThirdChild = styled(Child)`
   left: 32px;
   animation: ${loadingSecond} 0.6s infinite;
`;

const FourthChild = styled(Child)`
   left: 56px;
   animation: ${loadingThird} 0.6s infinite;
`;

const Wrapper = styled.div`
   display: inline-block;
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   width: 80px;
   height: 80px;
`;

export default Loader;
